<template>
  <div class="checkRecord">
    <div class="ele-table-tool ele-table-tool-default">
      <span>日期：</span>
      <el-date-picker
        v-model="table.where.date"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        style="margin-right: 10px; width: 150px"
      />
      <span>班级：</span>
      <el-select v-model="table.where.classId" placeholder="请选择班级" style="margin-right: 10px; width: 150px">
        <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id" />
      </el-select>
      <span>检查项目一级：</span>
      <el-select v-model="table.where.firstId" placeholder="请选择检查项目(一级)" style="margin-right: 10px; width: 150px" @change="getReasonListSec">
        <el-option v-for="item in reasonListFirst" :key="item.id" :label="item.egiName" :value="item.id" />
      </el-select>
      <span>检查项目二级：</span>
      <el-select v-model="table.where.twoId" placeholder="请选择检查项目(二级)" style="margin-right: 10px; width: 150px">
        <el-option v-for="item in reasonListSec" :key="item.id" :label="item.egiName" :value="item.id" />
      </el-select>
      <el-button @click="$refs.table.reload()" type="primary" icon="el-icon-search" class="ele-btn-icon" size="small">查询</el-button>
      <el-button @click="(table.where = { gradeId: gradeId }) && $refs.table.reload()" size="small">重置</el-button>
      <el-button @click="del()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除</el-button>
      <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出 </el-button>
    </div>
    <!-- 数据表格 -->
    <ele-data-table
      size="mini"
      ref="table"
      :config="table"
      :choose.sync="choose"
      :row-key="getRowKeys"
      highlight-current-row
      height="calc(100vh - 365px)"
    >
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column prop="interviewee" label="被检查受访者" show-overflow-tooltip />
        <el-table-column prop="className" label="班级" show-overflow-tooltip sortable />
        <el-table-column prop="egiName" label="检查项目" show-overflow-tooltip />
        <el-table-column prop="score" label="得分" show-overflow-tooltip />
        <el-table-column prop="inputDate" label="录入日期" show-overflow-tooltip />
        <el-table-column prop="signatory" label="督导员签名" show-overflow-tooltip />
        <el-table-column label="是否发送" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.sendType == 0 ? '未发出' : '已发出' }}
          </template>
        </el-table-column>
        <el-table-column label="照片" show-overflow-tooltip min-width="85">
          <template #default="{ row }">
            <el-button type="primary" @click="viewImg(row.img)" size="mini">点击查看照片</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <!--查看照片-->
    <el-dialog title="照片" :visible.sync="showImg" width="40%">
      <div v-if="imgUrl.length > 0" style="display: flex">
        <el-image v-for="(item, index) in imgUrl" :key="index" :src="item" alt="" style="width: 33%; height: auto" fit="contain" />
      </div>

      <div v-else>暂无图片数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImg = false">取 消</el-button>
        <el-button type="primary" @click="showImg = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑检查单统计-->
    <el-dialog title="编辑检查单" :visible.sync="showEdit" width="35%" @closed="checkForm = {}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="checkForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-form
          ref="checkForm"
          :model="checkForm"
          :rules="editRules"
          label-width="110px"
          style="
            max-width: 700px;
            margin: 10px auto;
            overflow-y: scroll;
            overflow-x: scroll;
          "
        >
          <el-form-item label="姓名:" prop="interviewee">
            <el-input v-model="checkForm.interviewee" placeholder="请输入姓名" clearable />
          </el-form-item>
          <el-form-item label="日期:" prop="inputDate">
            <el-date-picker v-model="checkForm.inputDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="违纪原因一级:" prop="egiId">
            <el-select v-model="egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable @change="getReasonListSec">
              <el-option v-for="(item, index) in reasonListFirst" :key="index" :label="item.egiName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="违纪原因二级:" prop="egiId">
            <el-select v-model="checkForm.egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable>
              <el-option v-for="(item, index) in reasonListSec" :key="index" :label="item.egiName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="分值:" prop="scoreId">
            <el-select v-model="checkForm.scoreId" placeholder="请选择分值" class="ele-fluid" clearable>
              <el-option v-for="(item, index) in scoreList" :key="index" :label="item.score" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="照片:" prop="photo">
            <el-upload
              class="avatar-uploader"
              list-type="picture-card"
              :action="$http.defaults.baseURL + '/file/getFilePath'"
              :headers="$http.defaults.headers.common"
              :data="{ path: 'checkListImg/' }"
              name="multipartFile"
              :limit="3"
              :file-list="fileList"
              :on-preview="handlePictureCardPreview"
              :on-remove="removeImg"
              :on-success="uploadSuccess"
              :before-upload="beforeAvatarUpload"
              accept="image/png,image/jpg,image/jpeg"
            >
              <!--              <img v-if="checkForm.img" :src="checkForm.img" class="avatar">-->
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="督察员签字:" prop="signatory">
            <el-input v-model="checkForm.signatory" placeholder="请输入督察员" clearable />
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="checkForm.remark" placeholder="请输入备注" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveEdit" :loading="loading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-form>
    </el-dialog>
    <!-- 照片预览 -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import {
    classListByGradeId,
    delExamineRecord,
    examineListExport,
    getItemListFirst,
    getItemLists,
    getItemScoreList,
    updateInformBill,
  } from '@/config/api';

  export default {
    name: 'CheckRecord',
    data() {
      return {
        gradeId: '',
        table: {
          // 表格配置
          url: '/educationExamine/examineList',
          where: {
            gradeId: '',
          },
          page: {
            page: 1,
            limit: 15,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        data: [],
        choose: [],
        imgUrl: [],
        showImg: false,
        classList: [],
        first: [],
        second: [],
        getRowKeys(row) {
          // 获取row的key值
          return row.id;
        },
        checkForm: {
          img: [],
        },
        showEdit: false,
        editRules: {
          interviewee: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          inputDate: [{ required: true, message: '请选择起止日期', trigger: 'change' }],
          egiId: [{ required: true, message: '请选择违纪原因', trigger: 'change' }],
          scoreId: [{ required: true, message: '请选择分则', trigger: 'change' }],
          signatory: [{ required: true, message: '请输入督察员', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        },
        scoreList: [],
        reasonListFirst: [],
        reasonListSec: [],
        egiId: '',
        loading: false,
        fileList: [],
        dialogVisible: false,
        dialogImageUrl: null,
      };
    },
    mounted() {
      // 获取违纪原因列表
      this.getReasonListFirst();
      // 获取分值列表
      this.getSocreList();
    },
    methods: {
      // 获取违纪原因列表
      getReasonListFirst() {
        getItemListFirst().then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListFirst = res.data.data;
          }
        });
      },
      // 获取分值列表
      getSocreList() {
        getItemScoreList().then((res) => {
          if (res.data.resCode == 200) {
            this.scoreList = res.data.data;
          }
        });
      },
      //照片上传限制
      beforeAvatarUpload(file) {
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1) === 'png';
        const extension2 = file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg';
        if (!extension && !extension2) {
          this.$message.error('只能上传png、jpg格式的图片');
          return false;
        }
      },
      // 上传单个照片成功
      uploadSuccess(res) {
        if (res.resCode == 200) {
          // this.checkForm.img = res.data[0].fileUrl;
          this.checkForm.img.push({
            name: res.data[0].fileName,
            url: res.data[0].fileUrl,
          });
        }
      },
      // 预览照片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 移除照片的钩子
      removeImg(file, fileList) {
        console.log(fileList);
        this.checkForm.img.forEach((item, index) => {
          if (file.name == item.name) {
            this.checkForm.img.splice(index, 1);
          }
        });
      },
      // 获取班级列表
      getClassList(gradeId) {
        classListByGradeId({ id: gradeId }).then((res) => {
          if (res.data.resCode == 200) {
            this.classList = res.data.data;
          }
        });
      },
      // 获取检查单项目一级列表
      getFirst() {
        getItemListFirst().then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListFirst = res.data.data;
          }
        });
      },
      getReasonListSec(item) {
        getItemLists({ id: item }).then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListSec = res.data.data;
          }
        });
      },
      // 删除检查单
      del() {
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let idList = this.choose.map((d) => d.id);
        this.$confirm('确定要删除选中的检查单吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          delExamineRecord({ ids: idList.join(',') })
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: '已删除' });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        });
      },
      // 查看照片
      viewImg(img) {
        console.log(img);
        this.showImg = true;

        if (img != '') {
          this.imgUrl = img.split(',');
        } else {
          this.imgUrl = [];
        }
      },
      // 编辑检查单
      edit(row) {
        this.checkForm = Object.assign({}, row);
        this.fileList = row.img.split(',').map((item) => {
          return { url: item };
        });
        this.checkForm.img = row.img.split(',').map((item) => {
          return { url: item };
        });
        this.egiId = row.firstId;
        this.getReasonListSec(row.firstId);
        this.showEdit = true;
      },
      // 编辑保存
      saveEdit() {
        this.$refs['checkForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.checkForm.img = this.checkForm.img.map((d) => d.url).join(',');
            let formData = new FormData();
            for (let key in this.checkForm) {
              if (this.checkForm[key] !== null && this.checkForm[key] !== undefined) {
                formData.append(key, this.checkForm[key]);
              }
            }
            updateInformBill(formData).then((res) => {
              this.loading = false;
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: '修改成功' });
                this.showEdit = false;
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 导出数据
      exportData() {
        let data = this.table.where;
        examineListExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  /*.avatar-uploader-icon {*/
  /*  font-size: 28px;*/
  /*  color: #8c939d;*/
  /*  width: 120px;*/
  /*  height: 120px;*/
  /*  line-height: 120px;*/
  /*  text-align: center;*/
  /*  border: 1px dashed #cccccc;*/
  /*}*/
  .avatar-uploader-icon:hover {
    border: 1px dashed #3aa1ff;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>
